import ChangeHistoryCardSeparator from "./Separator";
import ChangeHistoryCardTimeLabel from "./TimeLabel";
import ChangeHistoryCardVersionBadges from "./VersionBadges";

type ChangeHistoryCardVersionSummaryProps = {
  from: string;
  to: string;
  timeLabel: string;
};

const ChangeHistoryCardVersionSummary = ({
  from,
  to,
  timeLabel,
}: ChangeHistoryCardVersionSummaryProps) => (
  <>
    <ChangeHistoryCardVersionBadges from={from} to={to} />
    <ChangeHistoryCardSeparator />
    <ChangeHistoryCardTimeLabel timeLabel={timeLabel} />
  </>
);

export default ChangeHistoryCardVersionSummary;
